import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router-dom';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import theme from '../../../theme';
import { ROUTE_CONSTANTS } from '../../../views/app/RouteBuilding/routeConstants';
import TextLink from '../../TextLink/TextLink';

import CandidateAgencySelectionModal from './CandidateAgencySelectionModal';
import RecruiterAgencySelectionModal from './RecruiterAgencySelectionModal';

const styles = theme?.components?.userCard;
const AgencyCard = ({ agency, userName, userId, userRole, userRecruiter, externalAgencyId }) => {
  const [isAgencySelectionModalOpen, setIsAgencySelectionModalOpen] = useState(false);
  const recruiterId = userRecruiter?.ID;
  const recruiterPath = recruiterId
    ? generatePath(`/${ROUTE_CONSTANTS.USERS_V2_DETAIL}`, { id: recruiterId })
    : undefined;
  return (
    <>
      <Box sx={{ mt: 2, mb: 1 }}>
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Typography sx={styles.subTitleStyle}>{LanguageConverter('userCard.agency')} </Typography>
          <Typography sx={styles.agencyStyle}>{agency?.name}</Typography>
        </Box>
        {userRecruiter && (
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography sx={styles.subTitleStyle}>
              {LanguageConverter('userCard.recruiter')}
            </Typography>
            <TextLink to={recruiterPath} sx={{ ...styles.agencyStyle, cursor: 'pointer' }}>
              {userRecruiter?.name}
            </TextLink>
          </Box>
        )}
        {externalAgencyId && (
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography sx={styles.subTitleStyle}>
              {LanguageConverter('userCard.externalAgencyId')}
            </Typography>
            <Typography>{externalAgencyId}</Typography>
          </Box>
        )}

        <Button
          variant="contained"
          fullWidth
          sx={styles.deactivateButtonStyle}
          onClick={() => setIsAgencySelectionModalOpen(true)}
        >
          {LanguageConverter('userCard.changeAgency')}
        </Button>
      </Box>
      {userRole === UserRole.RECRUITER && (
        <RecruiterAgencySelectionModal
          userAgency={agency}
          userName={userName}
          open={isAgencySelectionModalOpen}
          onClose={() => setIsAgencySelectionModalOpen(false)}
          userId={userId}
          userRole={userRole}
        />
      )}
      {userRole === UserRole.CANDIDATE && isAgencySelectionModalOpen && (
        <CandidateAgencySelectionModal
          userAgency={agency}
          onClose={() => setIsAgencySelectionModalOpen(false)}
          userId={userId}
          userRecruiter={userRecruiter}
          externalAgencyId={externalAgencyId}
        />
      )}
    </>
  );
};

AgencyCard.propTypes = {
  agency: PropTypes.shape({
    name: PropTypes.string,
    ID: PropTypes.string,
  }),
  userRecruiter: PropTypes.shape({
    name: PropTypes.string,
    ID: PropTypes.string,
  }),
  userName: PropTypes.string.isRequired,
  userId: PropTypes.string,
  userRole: PropTypes.string,
  externalAgencyId: PropTypes.string,
};

export default AgencyCard;
